import React from 'react';

import { IconNotificationCenter, IconNotificationFilled, IconSearch } from '@xingternal/icons';

import { useBreakpoints, useLoginStates } from '@/hooks';

import { useSearchAlertModal, useSearchAlertsContext } from '../../contexts';
import { useSearch } from '../../hooks/use-search';
import { SearchAlertBannerCta } from './search-alert-banner-cta';
import { SearchAlertBannerText } from './search-alert-banner-text';

import * as S from './search-alert-banner.styles';

export const SearchAlertBanner: React.VFC = () => {
  const { loading } = useSearch();
  const { isLoggedIn } = useLoginStates();
  const { isMobile } = useBreakpoints();
  const {
    toggleAlert,
    isAlertActive,
    areAlertsInitialized,
    alertQuery: { keywords, location },
    isMaximumReached,
  } = useSearchAlertsContext();
  const { isValidQuery, toggleModal } = useSearchAlertModal();

  const onClickHandler = (): void => {
    if (!isLoggedIn || !isValidQuery) {
      toggleModal({ propActionOrigin: 'jobs_bell_link' });
    } else {
      toggleAlert({ propTrackActionData: { PropActionOrigin: isAlertActive ? 'jobs_toggel_off' : 'jobs_toggel_on' } });
    }
  };

  const isShown = !loading && Boolean(keywords || location);

  return (
    <S.Banner show={isShown} display="fixed">
      <S.Icon
        as={
          !isLoggedIn
            ? IconSearch
            : !isAlertActive || isMaximumReached
            ? IconNotificationCenter
            : IconNotificationFilled
        }
        width={24}
        height={24}
      />
      <S.Body lineHeight="dense">
        <label id="search-alert-banner-toggle">
          <SearchAlertBannerText {...{ isMobile, isLoggedIn, isAlertActive, isMaximumReached, location, keywords }} />
        </label>
      </S.Body>
      <SearchAlertBannerCta
        {...{
          isLoggedIn,
          isAlertActive,
          isMaximumReached,
          areAlertsInitialized,
          onClickHandler,
        }}
      />
    </S.Banner>
  );
};
